import { render, staticRenderFns } from "./Answer.vue?vue&type=template&id=1d077426&scoped=true&"
import script from "./Answer.vue?vue&type=script&lang=js&"
export * from "./Answer.vue?vue&type=script&lang=js&"
import style0 from "./Answer.vue?vue&type=style&index=0&id=1d077426&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d077426",
  null
  
)

export default component.exports